// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-quinn-residences -> quinn-residences-websites -> towns-on-church
// Generated: 2026-10-29T18:32:41.765Z
// Counts: 0 design, 44 content, 48 slot group, 0 collection binding, 6 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>3 & 4 Bedroom Townhomes in Decatur, GA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "easy-fee-guide-hero.lead": {
    "overrideType": "VALUE",
    "customValue": "<p>A simple breakdown of the fees, services, and optional costs associated with living at <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "easy-fee-guide-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Know your costs before you move in.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "engrain-sitemap.height": {
    "overrideType": "VALUE",
    "customValue": "1000",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.lead": {
    "overrideType": "VALUE",
    "customValue": "<p>Compare layouts, check availability, and find the space that fits how home needs to work.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "nextstep.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Find a Townhome That Fits Your Needs</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourquestions.when_a": {
    "overrideType": "VALUE",
    "customValue": "<p>The scheduler shows the times you can book.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.widget.self_guided_tour_link": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_self_guided_tour_url"
  },
  "tourscheduler.widget.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.widget.use_leads_tour_times": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Townhome Amenities in Decatur, GA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Inside, you get an in-unit washer and dryer, a dishwasher and efficient appliances, hardwood-style floors, and an electronic thermostat. Outside, there's a private patio or balcony, and lawn maintenance means the yard work is handled for you. See the full list on our <a href=\"/amenities\">amenities page</a>.</p>",
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Townhome features that keep life simple</p>",
    "mappedField": null
  },
  "amenityhighlights.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Life at Towns on Church centers on a landscaped courtyard, manicured lawns and tree-lined walkways, all kept neat with included lawn maintenance. See more of the grounds in our <a href=\"/gallery\">photo gallery</a>.</p>",
    "mappedField": null
  },
  "amenityhighlights.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Everyday Features Designed for Convenience</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "aroundthearea.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover What's Around Towns on Church</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Contact Towns on Church</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactdetails.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Our Leasing Team Is Here to Help</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "feetable.concierge_note": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Includes bi-annual filter changes, exterior pest control, 24-hour maintenance response for emergencies, and positive credit reporting.</p>",
    "mappedField": null
  },
  "floorplanshero.offer_label": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Reduced deposit and waived fees</p>",
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Photos of Towns on Church</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Townhomes for Rent in Decatur, GA</p>",
    "generatedValue": "<p>New three-bedroom townhomes in North Decatur</p>",
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore Interactive Leasing</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemapcallout.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Find your open townhome on the community map.</p>",
    "mappedField": null
  },
  "lifestylehighlights.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>At Towns on Church, the week plays out at home: coffee on your own private deck, neighbors running into each other on the courtyard lawns, and lawn maintenance that keeps your Saturdays free. When you want more room to roam, Medlock Park and <a href=\"/neighborhood\">Decatur Square</a> are just minutes away.</p>",
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore Decatur, GA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodcallout.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Church Street takes you straight down to Decatur Square for patio dinners and the MARTA Blue Line. North Decatur Road is a quick drive to Emory and the CDC, and you've got green space like Glenlake Park and Woodlands Garden for weekends. Explore more on our <a href=\"/neighborhood\">neighborhood page</a>.</p>",
    "mappedField": null
  },
  "neighborhoodcallout.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>North Decatur, off Scott Boulevard</p>",
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Pet Policy at Towns on Church</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Green lawns, landscaped walkways and private decks make daily walks and lazy afternoons easy, and Medlock Park and Glenn Creek Nature Preserve are close by for longer outings. Get the details in our <a href=\"/pet-policy\">pet policy</a>.</p>",
    "mappedField": null
  },
  "petpolicy.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Room to roam for your pets</p>",
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Towns on Church Privacy Policy</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover Three- and Four-Bedroom Townhome Living</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank You for Reaching Out</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyou.title": {
    "overrideType": "VALUE",
    "customValue": "<p>We Look Forward to Connecting With You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourgallery.title": {
    "overrideType": "VALUE",
    "customValue": "<p>See Our Decatur Townhomes in Person</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Schedule a Tour of Towns on Church</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "touroptions.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Walk through the Kennedy, Manning and Richard townhomes in 3D from your couch, then see one in person on a <a href=\"/schedule-a-tour\">self-guided tour</a> or with our leasing team.</p>",
    "mappedField": null
  },
  "touroptions.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore Spacious Townhome Floor Plans</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tours-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Virtual Tour of Towns on Church</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourembed.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Take a 3D walkthrough of our Kennedy and Manning three-bedroom townhomes or the four-bedroom Richard, then pick a tour and explore every floor at your own pace before you compare <a href=\"/floor-plans\">floor plans</a>.</p>",
    "mappedField": null
  },
  "virtualtourembed.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore Our Townhomes From Anywhere</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactdetails.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "",
        "customValue": "/thank-you"
      }
    }
  },
  "floorplanshero.link_fees": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/easy-fee-guide"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "floorplanshero.link_pets": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/pet-policy"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "whyquinn.pillar_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Easy access to great schools, shopping, dining, and everyday essentials."
      }
    }
  },
  "whyquinn.pillar_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Spacious layouts that blend functionality, comfort, and modern style."
      }
    }
  },
  "whyquinn.pillar_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Community-Focused Amenities"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Shared spaces designed to bring neighbors together and create lasting memories."
      }
    }
  },
  "whyquinn.pillar_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Dedicated support and personalized service for a hassle-free rental experience."
      }
    }
  },
  "whyquinn.pillar_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Energy-efficient homes built to reduce environmental impact and help lower your utility costs."
      }
    }
  },
  "amenitieslist.amenity_photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Lawn Maintenance"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167646/01a15ad3-1efb-7657-9533-17847d44ec9e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Row of modern townhomes with manicured lawns and walkways."
      }
    }
  },
  "amenitieslist.amenity_photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Electronic Thermostat"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167646/01a15ad2-fea1-74e9-8379-473124477978.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Spacious living room and open-concept kitchen with modern appliances."
      }
    }
  },
  "amenitieslist.amenity_photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Smart-Home Technology"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167646/01a15ad3-2222-767f-86fe-24e5bc68dde5.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room and kitchen with island and stainless steel appliances."
      }
    }
  },
  "amenitieslist.amenity_photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Washer/Dryer"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-5bd1-7781-9e7f-727ac1a5a9c8.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "White washer and dryer side by side in a townhome laundry room"
      }
    }
  },
  "amenitieslist.amenity_photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Hardwood Floors"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec34-e32a-7429-8676-b7f72802fdd1.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open living and kitchen area with light wood-style flooring and a central island"
      }
    }
  },
  "amenitieslist.amenity_photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Air Conditioner"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167646/01a15ad2-fbf0-7488-a274-b532fea2c0dc.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Empty bedroom with ceiling fan and blinds on windows"
      }
    }
  },
  "amenitieslist.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167646/019fec32-c4cd-737b-921f-8dde49471c0b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of Towns on Church townhomes around a central courtyard with walkways"
      }
    }
  },
  "amenitygroups.community_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167646/019fec32-c4cd-737b-921f-8dde49471c0b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of townhomes with central courtyard and walkways"
      }
    }
  },
  "amenitygroups.home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-433b-7166-9679-cd3a066801f8.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A kitchen with granite countertops and stainless steel appliances."
      }
    }
  },
  "amenityhighlights.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec34-c637-77a1-aa8c-7b9a69a2abf2.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A view of a courtyard between two buildings."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Courtyard"
      }
    }
  },
  "amenityhighlights.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167646/01a15ad3-1efb-7657-9533-17847d44ec9e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Row of modern townhomes with manicured lawns and walkways."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Walkways"
      }
    }
  },
  "amenityhighlights.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-19c6-71ef-9fdf-cbfce865fd19.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Private balcony with outdoor table and chairs overlooking townhomes."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Private Decks"
      }
    }
  },
  "amenityhighlights.card_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-4910-7078-9718-679b3598121c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with island and bar stools, stainless steel appliances, and dining area."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Granite Kitchens"
      }
    }
  },
  "amenityhighlights.card_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-5bd1-7781-9e7f-727ac1a5a9c8.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "In-home washer and dryer in a Towns on Church laundry room"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "In-Home Laundry"
      }
    }
  },
  "amenityhighlights.card_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-2db1-713b-83a3-eeb63a047373.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bathroom with double granite vanity and glass-enclosed shower"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Spa Baths"
      }
    }
  },
  "floorplanshero.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec34-a5d2-72ac-be6c-7feed28e43a8.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Towns on Church monument sign in front of modern townhomes with landscaping"
      }
    }
  },
  "floorplanshero.photo_10": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec34-f894-7268-a00c-9e46215be774.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Townhome exteriors with gray siding and brick accents along the street"
      }
    }
  },
  "floorplanshero.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-4910-7078-9718-679b3598121c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with island and bar stools, stainless steel appliances, and dining area."
      }
    }
  },
  "floorplanshero.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-532e-74f3-91e5-fd53747d4ba7.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Furnished living room with a grey sofa, coffee table and bright windows"
      }
    }
  },
  "floorplanshero.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-2461-731e-bbea-d6c67bcb10df.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Townhomes with attached garages and elevated private decks"
      }
    }
  },
  "floorplanshero.photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-3e42-744d-9317-2dd79a45ec3c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Deck with table and chairs, sliding glass door opening to living room with kitchen island."
      }
    }
  },
  "floorplanshero.photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-1640-7008-b5cd-b54522b3d1d6.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Dining area with a table and chairs in an open-concept townhome"
      }
    }
  },
  "floorplanshero.photo_7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-2a39-7539-90b8-4692434abade.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bright bedroom with a king-size bed, large wooden mirror and multiple windows"
      }
    }
  },
  "floorplanshero.photo_8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167646/01a15ad3-1fc4-744a-9a79-8dd1b04ed5de.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of modern townhomes with manicured lawns and parking areas."
      }
    }
  },
  "floorplanshero.photo_9": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-19c6-71ef-9fdf-cbfce865fd19.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Private balcony with outdoor table and chairs overlooking townhomes."
      }
    }
  },
  "lifestylehighlights.highlight_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Deck-side downtime"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Every townhome has its own private deck for morning coffee or a slow evening outside, just a sliding door away from the kitchen."
      }
    }
  },
  "lifestylehighlights.highlight_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Courtyard connections"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Manicured courtyard lawns and walkways link the townhomes, and included lawn maintenance keeps the green space ready for neighbors to meet up."
      }
    }
  },
  "lifestylehighlights.highlight_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Room to focus"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "With three bedrooms and smart-home tech, there's room to turn a spare room into a quiet home office set apart from everyday life."
      }
    }
  },
  "neighborhoodcallout.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec36-36ed-76eb-833a-1e6b0dde55e3.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Green lawns and trees at Glenlake Park in Decatur"
      },
      "caption": {
        "type": "GENERATOR",
        "generatedValue": "Glenlake Park"
      }
    }
  },
  "petpolicy.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167646/01a15ad3-1fc4-744a-9a79-8dd1b04ed5de.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of modern townhomes with manicured lawns and parking areas."
      },
      "caption": {
        "type": "GENERATOR",
        "generatedValue": "Manicured community lawns"
      }
    }
  },
  "propertyoverview.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec34-c30a-721b-ad73-28600c1cb12b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Townhome exteriors with light gray siding, brick foundations, and dark blue front doors"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Townhome Exteriors"
      }
    }
  },
  "propertyoverview.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec34-c637-77a1-aa8c-7b9a69a2abf2.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Courtyard between townhome buildings with manicured lawns and walkways"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Courtyard"
      }
    }
  },
  "propertyoverview.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-4910-7078-9718-679b3598121c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with island and bar stools, stainless steel appliances, and dining area."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen"
      }
    }
  },
  "propertyoverview.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-532e-74f3-91e5-fd53747d4ba7.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A living room with a grey couch, a brown ottoman, a coffee table, and a potted plant."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Living Room"
      }
    }
  },
  "propertyoverview.photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-19c6-71ef-9fdf-cbfce865fd19.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Private balcony with outdoor table and chairs overlooking townhomes."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Private Balcony"
      }
    }
  },
  "propertyoverview.photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-1640-7008-b5cd-b54522b3d1d6.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A dining room with a table and chairs."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Dining Area"
      }
    }
  },
  "reviewthemes.chip_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Fast maintenance"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "maintenance is quick and efficient!"
      }
    }
  },
  "reviewthemes.chip_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Friendly staff"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "she is so welcoming and nice"
      }
    }
  },
  "reviewthemes.chip_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Thanks to Pablo"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "excellent customer service, timeliness, and willingness"
      }
    }
  },
  "tourhero.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec34-c437-710d-98ac-defa6e0bcee6.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two-story townhomes at Towns on Church with gray and white siding, brick accents, large windows and a covered entry"
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
